import createAxiosInstance from 'src/utils/createAxiosInstance';
import { CLIENT_PORTAL_API_URL, EARCHIVE_API_URL } from 'src/utils/constants';

export const clientPortalApi = createAxiosInstance(CLIENT_PORTAL_API_URL);
export const eArchiveApi = createAxiosInstance(EARCHIVE_API_URL);
